import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentSearchComponent } from './student-search.component';

const routes: Routes = [{ path: '', component: StudentSearchComponent, title: 'Student Search' }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StudentSearchRoutingModule { }
